module.exports = [
  {
    text: `Иногда сундук — это просто сундук, но я бы не стал за это ручаться.`,
    author: `Третье правило выживания в подземельях Мистика X`,
  },
  'Иногда чудовище — это сам шкаф',
]
